import { AppPopupData } from 'src/app/bar/components/app-popup/app-popup.component';

export const WARNING_POPUP_BASE_DATA: AppPopupData = {
  showButtons: true,
  rightButtonStyle: { type: 'primary-danger', size: 117 },
  leftButtonStyle: { size: 117 },
  content: {
    secondaryButton: 'Cancel',
    primaryButton: 'Yes, I’m Sure',
  },
  titleStyle: { 'font-weight': '600' },
  messageStyle: { fontSize: '12px' },
};
export type warningPopupAction = 'remove' | 'priority';
export type warningPopupReason = 'noAccess';
type warningPopupContent = { title: string; message: Record<warningPopupReason, string> };
export const WARNING_POPUP_CONTENT: Record<warningPopupAction, warningPopupContent> = {
  remove: {
    title: 'Are you sure you want to </br> remove this link?',
    message: {
      noAccess: "It's advisable to consult with the Assistant's </br> creator before making any changes.",
    },
  },
  priority: {
    title: 'Are you sure you want to </br> change priority?',
    message: {
      noAccess: "It's advisable to consult with the Assistant's </br> creator before making any changes.",
    },
  },
};
